import { cn } from "@/utils/styles";
import React from "react";

export type TextInputProps = {
  value?: string;
  type?: string;
  disabled?: boolean;
  name: string;
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onPaste?: (e: React.ClipboardEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  error?: boolean;
  disabledOnWheel?: boolean;
};

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      onChange,
      value = "",
      name,
      placeholder,
      type = "text",
      className = "",
      disabled,
      error,
      onBlur,
      onKeyDown,
      onPaste,
      disabledOnWheel = false
    },
    ref
  ) => {
    return (
      <input
        ref={ref}
        spellCheck={false}
        disabled={disabled}
        style={{ boxShadow: "none" }}
        type={type}
        value={value}
        name={name}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        placeholder={placeholder}
        className={cn(
          "subtext-small h-[40px] flex-1 rounded-[8px] border border-gray-dark-900 bg-black px-3 py-[10px] text-white transition-colors placeholder:text-gray-dark-2200",
          error ? "border-red-dark-300" : "",
          className
        )}
        onWheel={disabledOnWheel ? (e) => (e.target as HTMLInputElement).blur() : undefined}
      ></input>
    );
  }
);

TextInput.displayName = "TextInput";

export default TextInput;
